import moment from 'moment';

import _ from 'lodash';
import 'twix';


export const EXCLUDED_DATES = [
  moment()
];
let date = moment()
let days = date.day() > 2 ? 4 : 3;
// console.log(days)
while (days > 0) {
  date = date.add(1, 'days');
  if (date.day() !== 0) {
      days -= 1;
      EXCLUDED_DATES.push(moment(date))
  }
}
// console.log(EXCLUDED_DATES)

export function excludedDatesForCampaing(day) {
  return day.day() === 0 || EXCLUDED_DATES.filter(d => d.isSame(day, 'days')).length > 0;
}

export function birthdayDatesRage(day) {
  const start = moment().subtract(30, 'days');
  const range = start
    .twix(moment().add(30, 'days'))
    .toArray('days')
    .map(v => v.format('DD/MM/YYYY'));
  const d = day.format('DD/MM/YYYY');
  return _.indexOf(range, d) === -1;
}

export function fifteenBlockRequest(day, totalDays=15) {
  console.log("totalDays", totalDays)
  const  start = moment().add(totalDays, 'days');
  const and = day;
  let sabado = false;
  let domingo = false;
  if(and.day() === 0){
    sabado = true       
  }
  
  if(and.day() === 6){
    domingo = true
  }

  const range = sabado ? start.add(2, 'days') : domingo ? start.add(1, 'days') : start 
    .twix(and) 
    .toArray('days')
    .map(v => v.format('DD/MM/YYYY'));
  const d = day.format('DD/MM/YYYY');
  return _.indexOf(range, d) === -1;
}

export function weekendBlocked(day){
  const  start = moment();
  const and = day;
  let sabado = false;
  let domingo = false;
  if(and.day() === 0){
    sabado = true       
  }
  
  if(and.day() === 6){
    domingo = true
  }

  const range = sabado ? start.add(2, 'days') : domingo ? start.add(1, 'days') : start 
    .twix(and) 
    .toArray('days')
    .map(v => v.format('DD/MM/YYYY'));
  const d = day.format('DD/MM/YYYY');
  return _.indexOf(range, d) === -1;
}

const next = moment(EXCLUDED_DATES.slice(-1)[0]).add(1, 'days');

export const nextDayAvailable = next.day() === 0 ? next.add(1, 'days') : next;




// WEBPACK FOOTER //
// ./src/utils/excludedDates.js